import { useLiveData } from './useLiveData';
import { ipApi } from '../services/api';
import { mergeEmrSettings } from '../config/emrSettings';

/** Hospital EMR/Rx pad settings + current user's quick medicines. */
export function useEmrSettings() {
  const { data, loading, error, reload } = useLiveData(
    () => ipApi.getEmrSettings(),
    []
  );
  const settings = mergeEmrSettings(data?.settings);
  return {
    settings,
    genieMeds: data?.genieMeds || [],
    loading,
    error,
    reload,
  };
}
